import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { StudentApi, studentsApi } from "api/studentsApi";
import { useToaster } from "utils";
import { PaziaFormButton, PaziaTextarea } from "components/atoms";
import { PaziaModal } from "components/molecules";

interface BlockUserModalProps {
  onCloseRequest: () => void;
  user: StudentApi | null;
}

export const BlockUserModal = ({ onCloseRequest, user }: BlockUserModalProps) => {
  const { showSuccess } = useToaster();
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset } = methods;

  const onSubmit = async (data: BlockUserFormValues) => {
    await studentsApi.block(user!.id, data);
    onCloseRequest();
    showSuccess("Użytkownik został zablokowany");
    reset({});
  };

  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={user != null}>
      {user && (
        <div className="flex flex-col gap-4 px-5 pb-6 pt-4">
          <div className="text-xl">
            <span className="mb-2 font-medium text-slate-800 dark:text-slate-100">
              Blokowanie użytkownika {user.firstName} {user.surname}
            </span>
          </div>
          <div>
            Następujące parametry zostaną zablokowane <br />
            Numer PESEL : <b>{user.pesel}</b> <br />
            Email : <b>{user.email}</b> <br />
          </div>

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
              <PaziaTextarea name={FORM_NAMES.REASON} label="Powód blokady" />
              <PaziaFormButton title="Zatwierdź" />
            </form>
          </FormProvider>
        </div>
      )}
    </PaziaModal>
  );
};

const FORM_NAMES = {
  REASON: "reason",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.REASON]: yup.string().required(),
  })
  .required();

export type BlockUserFormValues = yup.InferType<typeof schema>;
